import React, { useEffect, useState } from 'react';
import { useTopbarContext } from '../TopbarContext';
import { useRequest } from '../../../hooks/useRequest';
import { getMarketplaceListings } from '../../../util/api';
import {
    getNearbyUserLocationListings,
    setNearbyUserLocationListings,
} from '../../../util/localStorage';

const twoWeeksAgo = new Date();
twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

export const useNewlyCreatedListings = params => {
    const [listings, setListings] = useState([]);
    const { showNewListingsStatisticsForLoggedOutUser, currentUserGeoData } = useTopbarContext();
    const { error, loading, request } = useRequest();

    const geoDataDefined = Boolean(
        currentUserGeoData && currentUserGeoData.origin && currentUserGeoData.bounds
    );
    const requestAllowed = geoDataDefined && showNewListingsStatisticsForLoggedOutUser;

    const requestNewlyCreatedListings = async () => {
        const hash = [...JSON.stringify(params)].reduce(
            (h, c) => (h = Math.imul(31, h) + c.charCodeAt()) & h,
            0
        );
        const storage = getNearbyUserLocationListings();

        if (storage && storage[hash]) {
            return setListings(storage[hash]);
        }

        return await request(
            () =>
                getMarketplaceListings(
                    new URLSearchParams({
                        createdAtStart: twoWeeksAgo.toISOString(),
                        origin: `${currentUserGeoData.origin.lat}, ${currentUserGeoData.origin.lng}`,
                        ...(params || {}),
                    })
                ),
            data => {
                if (!storage[hash]) {
                    setNearbyUserLocationListings({
                        ...getNearbyUserLocationListings(),
                        [hash]: data,
                    });
                }
                setListings(data);
            }
        );
    };

    useEffect(() => {
        if (!requestAllowed) return;

        requestNewlyCreatedListings();
    }, [requestAllowed]);

    return { listings, error, loading };
};
